import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { RepoContact } from '../../models/repo-business/repo-business.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { RepoContactListDataSource } from './repocontact-list.datasource';
import Swal from 'sweetalert2';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { RepoBusinessService } from '../../shared-new/services/repo-business.service';
import { ToastService } from '../../shared-new/services/toast.service';
import { RepoBusinessFacade } from '../../shared-new/store/repo-business/repo-business.facade';
@Component({
  selector: 'app-repocontact-list',
  templateUrl: './repocontact-list.component.html',
  styleUrls: ['./repocontact-list.component.scss']
})
export class RepocontactListComponent extends BaseUnsubscribeComponent implements OnInit {
  @Input() public isShowOrgCol: boolean = false;
  @Input() public selectedContactId: number = 0;
  @Input() public selectedBusinessId: number = 0;
  @Input() tableContact: ElementRef;
  @Output() editRepoContact = new EventEmitter();
  @ViewChild(MatSort) contactSort: MatSort;
  @Input() public isUSA = false;
  private _searchTerm: string = '';
  @Input() public set searchTerm(value: string) {
    this._searchTerm = value;
    if (this.dataSource) {
      this.dataSource.searchTable(value);
    }
  }
  public get searchTerm(): string {
    return this._searchTerm;
  }
  @Input() public set contacts(contacts: RepoContact[]) {
    if (contacts) {
      setTimeout(() => {
        const scrollLevel = this.dataSource?.infiniteScrollLevel || 20;
        this.dataSource = new RepoContactListDataSource(contacts, this.contactSort, false, scrollLevel);
        if (this.searchTerm) {
          this.dataSource.searchTable(this.searchTerm);
        }
      }, 100);
    }
  }

  public dataSource: RepoContactListDataSource;

  constructor(private readonly repoBusinessFacade: RepoBusinessFacade,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private toastService: ToastService,
    private readonly repoBusinessService: RepoBusinessService) {
    super();
  }
  public trackByContact(index: number, contact: RepoContact): number {
    return contact.repoContactId;
  }
  ngOnInit(): void {

  }

  public get OrgTitle(): string {
    return this.isUSA ? 'Organizations' : 'Organisations';
  }
  public onTableScroll(): void {
    this.dataSource.onScroll();
  }

  public EditContact(repoContact: RepoContact): void {
    this.editRepoContact.emit(repoContact);
  }

  public DeleteRepoContact(contact: RepoContact) {
    Swal.fire({
      title: 'Remove Contact',
      html: `Are you sure you want to remove the contact? This is an irreversible action.`,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Delete',
      confirmButtonColor: '#1b6da6',
    }).then((result) => {
      if (result.isConfirmed) {
        this.repoBusinessService
          .deleteContact(contact.repoContactId)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: () => {
              this.toastService.success('Contact deleted successfully');
              if (this.selectedBusinessId > 0) {
                this.repoBusinessFacade.loadRepoBusinesses();
                this.repoBusinessFacade.loadContactsByRepoBusinessId(this.selectedBusinessId);
              } else {
                if (contact.repoBusiness?.repoBusinessId && contact.repoBusiness?.repoBusinessId > 0) {
                  this.repoBusinessFacade.loadRepoBusinesses();
                }
                this.repoBusinessFacade.loadContacts();
              }
            },
            error: (error) => {
              this.httpErrorHandlerService.ShowErrorMessage(error);
            },
          });
      }
    });
  }

  public get displayedColumns$(): BehaviorSubject<string[]> {
    if (!this.isShowOrgCol) {
      return new BehaviorSubject([
        'salutation',
        'firstName',
        'lastName',
        'email',
        'countryCode',
        'mobile',
        'position',
        'actions',
      ]);
    } else {
      return new BehaviorSubject([
        'salutation',
        'firstName',
        'lastName',
        'Org',
        'email',
        'countryCode',
        'mobile',
        'position',
        'actions',
      ]);
    }
  }

}
